"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = require("prop-types");
var _environmentBadge = require("./environmentBadge.helper");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var EnvironmentBadge = function EnvironmentBadge(_ref) {
  var environment = _ref.environment,
    uniqueID = _ref.uniqueID;
  return _react.default.createElement("span", {
    className: (0, _classnames.default)('agillicEnvironmentBadge', environment),
    title: (0, _environmentBadge.capitalizeString)(environment),
    "data-testid": uniqueID
  }, environment);
};
EnvironmentBadge.propTypes = {
  environment: (0, _propTypes.oneOf)(['staging', 'production']).isRequired,
  uniqueID: _propTypes.string
};
var _default = EnvironmentBadge;
exports.default = _default;